import * as Yup from "yup";

export const DepartmentLevelFormValidation = Yup.object({
    description: Yup.string()
        .required("Description is required")
        .min(1)
        .max(150),
    depth: Yup.number()
        .required("Depth is required")
        .integer("Depth must be a whole number")
        .min(1, "Depth starts at 1"),
});
